import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Lightbox } from 'ngx-lightbox';
import { tap } from 'rxjs';
import { HelpersService } from '@evento-ng/libs';
import { TicketService } from 'src/app/shared/services/ticket.service';
@Component({
  selector: 'app-ticket-card',
  templateUrl: './ticket-card.component.html',
  styleUrls: ['./ticket-card.component.scss'],
})
export class TicketCardComponent {
  @Input() ticketSchedule: any;
  @Input() schedule: any;
  dateTimes: any[] = [];
  counter = 0;
  ticketForm: FormGroup;
  item: any;
  ticketExpanded = true;
  albums: any = [];
  isMobile = false;
  constructor(
    public translate: TranslateService,
    public ticketService: TicketService,
    public fb: FormBuilder,
    public helpers: HelpersService,
    private _lightbox: Lightbox
  ) {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  open(index: number): void {
    // open lightbox
    this._lightbox.open(this.albums, index, {
      centerVertically: true,
      showImageNumberLabel: true,
      wrapAround: true,
      albumLabel: '%1 / %2',
    });
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

  deleteItem(): void {
    this.counter = 0;
    this.ticketService.deleteItem(this.item);
  }

  ngOnChanges() {
    this.counter = 0;
    this.ticketService.bookTicket$
      .pipe(
        tap((res) => {
          const ticket = res?.items?.find((x) => {
            if (
              x.schedule?.id === this.schedule.id &&
              x.ticket.id === this.ticketSchedule.ticket.id
            ) {
              return x;
            }
          });
          if (ticket) {
            this.counter = ticket.quantity;
          }
          this.ticketForm?.valueChanges.subscribe((res) => {
            if (res?.time) {
              const item = this.dateTimes.find((x) => x.id === res.time);
              this.ticketService.updateBookTicketItems({
                ticket: this.ticketSchedule.ticket,
                time: item,
                schedule: this.schedule,
              });
            }
          });

          this.showSelectTimes();
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.ticketService.ItemDeleted.subscribe((res: any) => {
      if (this.ticketSchedule.ticket.id == res.ticket.id) {
        this.counter = 0;
      }
    });
    this.ticketService.reset.subscribe((res: any) => {
      this.counter = 0;
    });
    if (this.ticketSchedule.ticket?.attachments?.length > 0) {
      for (let i = 0; i < this.ticketSchedule.ticket.attachments.length; i++) {
        const src = this.ticketSchedule.ticket.attachments[i].url;
        const album = {
          src: src,
        };

        this.albums.push(album);
      }
    }

    this.initForm();
  }

  private initForm(): void {
    let time = '';
    const bookTicket = this.ticketService.bookTicket.getValue();
    this.item = bookTicket?.items?.find(
      (x) =>
        x.schedule.id === this.schedule.id &&
        x.ticket.id === this.ticketSchedule.ticket.id
    );
    if (this.item) {
      time = this.item.time?.id || '';
    }
    this.ticketForm = this.fb.group({
      schedule: [{ value: null }],
      time: [time],
    });
  }

  showSelectTimes(): void {
    if (this.ticketSchedule.ticket.isScheduled) {
      if (this.ticketSchedule.timeSchedules.length && this.counter > 0) {
        this.dateTimes = this.ticketSchedule.timeSchedules.map((x) => {
          return {
            time: x?.time?.startAt,
            id: x?.time?.id,
          };
        });

        return;
      }
      this.dateTimes = [];
    }
  }

  increaseCount(): void {
    if (this.ticketSchedule.ticket.minimumPerOrder > this.counter) {
      this.counter = this.ticketSchedule.ticket.minimumPerOrder;
      this.onCounterChanged();
      return;
    }
    this.counter = this.counter + 1;
    this.onCounterChanged();
  }

  decreaseCount(): void {
    if (this.counter === 0) {
      return;
    }
    this.counter = this.counter - 1;
    this.onCounterChanged();
  }

  increaseCountEnabled() {
    if (this.ticketSchedule.ticket.maximumPerOrder > this.counter) {
      return true;
    } else {
      return false;
    }
  }

  decreaseCountEnabled() {
    if (this.counter > this.ticketSchedule.ticket.minimumPerOrder) {
      return true;
    } else {
      return false;
    }
  }

  isDateSame(first: Date, second: Date): boolean {
    return (
      first.getMonth() + 1 === second.getMonth() + 1 &&
      first.getDate() + 1 === second.getDate()
    );
  }

  disabledDate(): void {
    if (this.counter === 0) {
      this.ticketForm?.patchValue({
        schedule: null,
        time: '',
      });
      this.dateTimes = [];
      return;
    }
  }

  ResetCounter() {
    this.counter = 0;
    this.onCounterChanged();
  }

  onCounterChanged(): void {
    this.ticketService.updateBookTicketItems({
      ticket: this.ticketSchedule.ticket,
      quantity: this.counter,
      schedule: this.schedule,
      ticketSchedule: this.ticketSchedule,
    });
    if (this.item) {
      this.ticketService.updateBookTicketItems({
        ticket: this.ticketSchedule.ticket,
        quantity: this.counter,
        schedule: this.schedule,
        ticketSchedule: this.ticketSchedule,
        time: this.item.time,
      });
    }

    this.showSelectTimes();
    this.disabledDate();
  }

  myFunction(index) {
    var dots = document.getElementById('dots-' + index);
    var moreText = document.getElementById('more-' + index);
    var btnText = document.getElementById('myBtn-' + index);

    if (dots.style.display === 'none') {
      dots.style.display = 'inline';
      btnText.innerHTML = this.translate.instant('readMore');
      moreText.style.display = 'none';
    } else {
      dots.style.display = 'none';
      btnText.innerHTML = this.translate.instant('readLess');
      moreText.style.display = 'inline';
    }
  }
}
